export const LIST_WIDTH = 272
export const DOMAIN_ITEM_HEIGHT = 60
export const ORG_ITEM_HEIGHT = 42
export const MAX_LIST_HEIGHT = 366
export const MIN_LIST_HEIGHT = 120
export const TAB_BAR_HEIGHT = 36
